import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Pagination, Autoplay, Navigation } from 'swiper/modules';

const ITConsulting = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            {/* Breadcrumb Section */}
            <section className="breadcrumb-hero">
                <div className="breadcrumb-overlay"></div>
                <div className="breadcrumb-content">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <h1 className="breadcrumb-title">
                                    IT <span className="breadcrumb-highlight">Consulting</span>
                                </h1>
                                <Link to="/services" style={{ textDecoration: 'none' }}>
                                    <button className="breadcrumb-btn">
                                        <span>Our Services</span>
                                        <span className="breadcrumb-arrow">
                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        </span>
                                    </button>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="breadcrumb-pattern"></div>
            </section>

            {/* Hero Section */}
            <section className="digital-presence-hero">
                <div className="container">
                    <div className="row align-items-center g-5">
                        <div className="col-lg-6">
                            <div className="hero-badge">
                                <span className="badge-dot"></span>
                                Trusted IT Consulting Partner
                            </div>
                            <h2 className="intro-about-heading">
                                Transform Your Business With
                                <span className="text-gradient"> Strategic IT Consulting</span>
                            </h2>
                            <p className="hero-description">
                                Empower your organization with <span className="text-blue-highlight">expert technology guidance</span> that drives innovation, optimizes operations, and ensures sustainable growth. From digital transformation to infrastructure optimization, we're your trusted IT advisors.
                            </p>
                            <div className="hero-buttons">
                                <button className="btn-hero-secondary">
                                    Schedule Consultation →
                                </button>
                            </div>
                            <div className="hero-stats">
                                <div className="stat-card">
                                    <h3 className="stat-number">500+</h3>
                                    <p className="stat-label">Consulting Projects</p>
                                </div>
                                <div className="stat-card">
                                    <h3 className="stat-number">8+</h3>
                                    <p className="stat-label">Years Experience</p>
                                </div>
                                <div className="stat-card">
                                    <h3 className="stat-number">95%</h3>
                                    <p className="stat-label">Client Retention</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="hero-image-container">
                                <img src={require('../../assets/images/it-consulting.jpg')} alt="IT Consulting Hero" className="img-fluid rounded shadow-md" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Comprehensive IT Consulting Services Section */}
            <section className="comprehensive-design-section py-5">
                <div className="container">
                    <div className="text-center mb-5">
                        <div className="expertise-badge">
                            Our Expertise
                        </div>
                        <h2 className="comprehensive-title">
                            Comprehensive IT Consulting Services
                        </h2>
                        <p className="comprehensive-subtitle">
                            Strategic technology solutions to drive your business forward
                        </p>
                    </div>

                    <div className="row g-4">
                        {/* Digital Transformation */}
                        <div className="col-lg-4 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">🔄</span>
                                </div>
                                <h3 className="solution-card-title">Digital Transformation</h3>
                                <p className="solution-card-description">
                                    Modernize your business operations with cutting-edge digital solutions and strategic technology adoption
                                </p>
                                <a href="#" className="solution-learn-more">
                                    Learn More →
                                </a>
                            </div>
                        </div>

                        {/* IT Strategy & Planning */}
                        <div className="col-lg-4 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">📊</span>
                                </div>
                                <h3 className="solution-card-title">IT Strategy & Planning</h3>
                                <p className="solution-card-description">
                                    Develop comprehensive IT roadmaps aligned with your business objectives and growth vision
                                </p>
                                <a href="#" className="solution-learn-more">
                                    Learn More →
                                </a>
                            </div>
                        </div>

                        {/* Cloud Solutions */}
                        <div className="col-lg-4 col-md-6">
                            <div className="design-solution-card highlighted">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">☁️</span>
                                </div>
                                <h3 className="solution-card-title">Cloud Consulting</h3>
                                <p className="solution-card-description">
                                    Expert guidance on cloud migration, optimization, and management across AWS, Azure, and GCP
                                </p>
                                <a href="#" className="solution-learn-more">
                                    Learn More →
                                </a>
                            </div>
                        </div>

                        {/* Cybersecurity */}
                        <div className="col-lg-4 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">🔒</span>
                                </div>
                                <h3 className="solution-card-title">Cybersecurity Advisory</h3>
                                <p className="solution-card-description">
                                    Protect your assets with comprehensive security assessments, compliance, and risk management
                                </p>
                                <a href="#" className="solution-learn-more">
                                    Learn More →
                                </a>
                            </div>
                        </div>

                        {/* Infrastructure Optimization */}
                        <div className="col-lg-4 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">⚙️</span>
                                </div>
                                <h3 className="solution-card-title">Infrastructure Optimization</h3>
                                <p className="solution-card-description">
                                    Enhance performance, reduce costs, and ensure scalability of your IT infrastructure
                                </p>
                                <a href="#" className="solution-learn-more">
                                    Learn More →
                                </a>
                            </div>
                        </div>

                        {/* Technology Assessment */}
                        <div className="col-lg-4 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">🔍</span>
                                </div>
                                <h3 className="solution-card-title">Technology Assessment</h3>
                                <p className="solution-card-description">
                                    In-depth analysis of your current technology stack with actionable recommendations for improvement
                                </p>
                                <a href="#" className="solution-learn-more">
                                    Learn More →
                                </a>
                            </div>
                        </div>
                    </div>

                    <div className="text-center mt-5">
                        <button className="btn-start-project">
                            Get Expert IT Guidance →
                        </button>
                    </div>
                </div>
            </section>

            {/* Why Choose Profit Technologies */}
            <section className="bespoke-section py-5" style={{ backgroundColor: '#f8f9fa' }}>
                <div className="container">
                    <div className="row align-items-center g-5">
                        <div className="col-lg-6">
                            <h2 className="section-main-title mb-4">
                                Why Choose Profit Technologies for IT Consulting?
                            </h2>
                            <p className="section-description">
                                <strong>Your Strategic Technology Partner</strong>
                            </p>
                            <p className="section-description">
                                At <strong>Profit Technologies</strong>, we bring deep technical expertise combined with business acumen to deliver IT consulting that drives real value. Our seasoned consultants have helped organizations of all sizes navigate complex technology challenges and achieve their digital ambitions.
                            </p>
                            <p className="section-description">
                                From Fortune 500 enterprises to emerging startups, we provide unbiased, vendor-neutral advice focused solely on your success. Our holistic approach ensures technology investments align with business goals and deliver measurable ROI.
                            </p>
                            <p className="section-description">
                                <strong>What sets us apart:</strong>
                            </p>
                            <ul className="section-description" style={{ paddingLeft: '20px' }}>
                                <li>✓ 8+ years of IT consulting excellence across diverse industries</li>
                                <li>✓ Certified experts in cloud, security, and enterprise architecture</li>
                                <li>✓ Vendor-neutral recommendations focused on your best interests</li>
                                <li>✓ Proven track record of successful digital transformations</li>
                                <li>✓ Hands-on implementation support, not just documentation</li>
                                <li>✓ Continuous partnership through every stage of your IT journey</li>
                            </ul>
                        </div>
                        <div className="col-lg-6">
                            <div className="bespoke-image-wrapper">
                                <img
                                    src="https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&q=80"
                                    alt="Profit Technologies IT Consulting"
                                    className="img-fluid rounded"
                                    style={{ boxShadow: '0 10px 40px rgba(0,0,0,0.1)' }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Technologies & Platforms */}
            <section className="comprehensive-design-section py-5">
                <div className="container">
                    <div className="text-center mb-5">
                        <div className="expertise-badge">
                            Technology Stack
                        </div>
                        <h2 className="comprehensive-title">
                            Technologies & Platforms We Specialize In
                        </h2>
                        <p className="comprehensive-subtitle">
                            Deep expertise across the entire technology ecosystem
                        </p>
                    </div>

                    <div className="row g-4">
                        {/* Cloud Platforms */}
                        <div className="col-lg-3 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">☁️</span>
                                </div>
                                <h3 className="solution-card-title">Cloud Platforms</h3>
                                <p className="solution-card-description">
                                    AWS, Azure, Google Cloud, Oracle Cloud - migration and optimization
                                </p>
                            </div>
                        </div>

                        {/* Enterprise Software */}
                        <div className="col-lg-3 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">🏢</span>
                                </div>
                                <h3 className="solution-card-title">Enterprise Systems</h3>
                                <p className="solution-card-description">
                                    SAP, Oracle, Microsoft Dynamics, Salesforce consulting and integration
                                </p>
                            </div>
                        </div>

                        {/* DevOps & CI/CD */}
                        <div className="col-lg-3 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">🔧</span>
                                </div>
                                <h3 className="solution-card-title">DevOps Tools</h3>
                                <p className="solution-card-description">
                                    Jenkins, Docker, Kubernetes, Terraform for automated workflows
                                </p>
                            </div>
                        </div>

                        {/* Security Solutions */}
                        <div className="col-lg-3 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">🛡️</span>
                                </div>
                                <h3 className="solution-card-title">Security Tools</h3>
                                <p className="solution-card-description">
                                    Firewall, SIEM, DLP, IAM, and comprehensive security solutions
                                </p>
                            </div>
                        </div>

                        {/* Data & Analytics */}
                        <div className="col-lg-3 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">📊</span>
                                </div>
                                <h3 className="solution-card-title">Data Platforms</h3>
                                <p className="solution-card-description">
                                    Power BI, Tableau, Snowflake, BigQuery for data-driven insights
                                </p>
                            </div>
                        </div>

                        {/* Collaboration Tools */}
                        <div className="col-lg-3 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">💬</span>
                                </div>
                                <h3 className="solution-card-title">Collaboration</h3>
                                <p className="solution-card-description">
                                    Microsoft 365, Google Workspace, Slack, Teams implementation
                                </p>
                            </div>
                        </div>

                        {/* Infrastructure */}
                        <div className="col-lg-3 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">🖥️</span>
                                </div>
                                <h3 className="solution-card-title">Infrastructure</h3>
                                <p className="solution-card-description">
                                    VMware, Hyper-V, networking, storage, and datacenter solutions
                                </p>
                            </div>
                        </div>

                        {/* AI & Automation */}
                        <div className="col-lg-3 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">🤖</span>
                                </div>
                                <h3 className="solution-card-title">AI & Automation</h3>
                                <p className="solution-card-description">
                                    Machine learning, RPA, intelligent automation solutions
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Our Consulting Process */}
            <section className="comprehensive-design-section py-5" style={{ backgroundColor: '#ffffff' }}>
                <div className="container">
                    <div className="text-center mb-5">
                        <div className="expertise-badge">
                            Our Approach
                        </div>
                        <h2 className="comprehensive-title">
                            Our Proven Consulting Methodology
                        </h2>
                        <p className="comprehensive-subtitle">
                            A structured approach that delivers tangible business outcomes
                        </p>
                    </div>

                    <div className="row g-4">
                        {/* Discovery & Assessment */}
                        <div className="col-lg-4 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">🔍</span>
                                </div>
                                <h3 className="solution-card-title">1. Discovery & Assessment</h3>
                                <p className="solution-card-description card-text-dst">
                                    Comprehensive analysis of your current IT landscape, challenges, and opportunities
                                </p>
                            </div>
                        </div>

                        {/* Strategy Development */}
                        <div className="col-lg-4 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">📋</span>
                                </div>
                                <h3 className="solution-card-title">2. Strategy Development</h3>
                                <p className="solution-card-description card-text-dst">
                                    Crafting tailored IT strategies aligned with your business goals and budget
                                </p>
                            </div>
                        </div>

                        {/* Roadmap Creation */}
                        <div className="col-lg-4 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">🗺️</span>
                                </div>
                                <h3 className="solution-card-title">3. Roadmap Creation</h3>
                                <p className="solution-card-description card-text-dst">
                                    Detailed implementation plans with clear milestones, timelines, and resource allocation
                                </p>
                            </div>
                        </div>

                        {/* Implementation Support */}
                        <div className="col-lg-4 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">🚀</span>
                                </div>
                                <h3 className="solution-card-title">4. Implementation</h3>
                                <p className="solution-card-description card-text-dst">
                                    Hands-on support during execution with agile methodologies and best practices
                                </p>
                            </div>
                        </div>

                        {/* Optimization */}
                        <div className="col-lg-4 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">⚡</span>
                                </div>
                                <h3 className="solution-card-title">5. Optimization</h3>
                                <p className="solution-card-description card-text-dst">
                                    Continuous improvement and fine-tuning to maximize performance and ROI
                                </p>
                            </div>
                        </div>

                        {/* Ongoing Partnership */}
                        <div className="col-lg-4 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">🤝</span>
                                </div>
                                <h3 className="solution-card-title">6. Ongoing Support</h3>
                                <p className="solution-card-description card-text-dst">
                                    Long-term partnership with regular reviews, updates, and strategic guidance
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default ITConsulting;
